import React, { useState, useRef } from "react";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import ModalActions from "components/ModalActions";
import { getEducationSlidesForKey } from "constants/education";
import { getEducation, setEducationSeen } from "utils/education";

const UnauthEducationModal = ({ uid: key }) => {
  const modalRef = useRef();
  const education = getEducation();
  const show = education && !education[key];

  const [showModal, setShowModal] = useState(show);

  const modalProps = {
    ref: modalRef,
    showModal,
    showCloseIcon: false,
    onClose: () => setShowModal(false)
  };

  return showModal ? (
    <Modal {...modalProps}>
      <ModalContent slides={getEducationSlidesForKey(key)}>
        <ModalActions
          actions={[
            {
              cta: "Got it",
              onClick: () => {
                setEducationSeen(key);
                setShowModal(false);
              }
            }
          ]}
        />
      </ModalContent>
    </Modal>
  ) : null;
};

export default UnauthEducationModal;
